const handleRedirect = (history, url) => {
  history.push(url);
};

export default handleRedirect;
